import "styles/error.css";

export function ErrorDisplay({ message }: { message: string }) {
  return (
    <div className="error-display">
      <p className="error-display-message">
        エラー：<span className="error-display-message-text">{message}</span>
      </p>
    </div>
  );
}
